<div class="inline-notification-icon" *ngIf="icon"><i class="{{ icon }}"></i></div>
<div class="inline-notification-content">
    <ng-content></ng-content>
</div>
